<template>
    <div class="app-container">
        <el-form :model="query" ref="form" size="mini" inline @submit.prevent>
            <slot name="filters"></slot>
            <el-form-item v-if="filters">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">
                    查询
                </el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">
                    清空
                </el-button>
            </el-form-item>
        </el-form>
        <el-row type="flex" justify="space-between">
            <div></div>
            <el-row type="flex">
                <slot name="btns"></slot>
            </el-row>
        </el-row>
        <el-row v-if="tabs">
            <slot name="tabs"></slot>
        </el-row>
        <el-row v-if="table">
            <el-table :tree-props="{ children: 'children' }" header-cell-class-name="table-header" border
                v-bind="$attrs" @selection-change="handleSelectionChange" style="margin: 20px 0">
                <slot name="columns"></slot>
            </el-table>
            <el-row type="flex" justify="end" v-if="pager">
                <el-pagination v-on="$listeners" :current-page="query.pageNo"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </el-row>
        </el-row>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: Object,
            default: () => ({})
        },
        total: {
            type: Number,
            default: 0
        },
        pager: {
            type: Boolean,
            default: true
        },
        filters: {
            type: Boolean,
            default: true
        },
        tabs: {
            type: Boolean,
            default: false
        },
        table: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleSearch() {
            this.$emit('search');
        },
        resetQuery() {
            this.$refs.form.resetFields();
            this.$emit('reset');
        },
        handleSelectionChange(rows) {
            this.$emit('selection-change', rows);
        }
    }
}
</script>

<style></style>